import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const VideoPlayerStyled = {
  Container: styled(Box) <any>`
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 118px;
    margin-bottom: 60px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      margin-top: 50px;
 
      }
  `,
};
